
import axios from 'axios';
import { BASE_API_URL } from './baseServices';
import { fetchWithAuth } from '../utils/api';

export const fetchDepartments = async (orgId) => {
    try {
        const response = await fetchWithAuth(`ADMINRoutes/getDepts?OrgId=${orgId}`, {
            method: 'GET',
        });
        const data = await response.json();
        return data.ResultData;
    } catch (error) {
        console.error('Error fetching departments:', error);
        throw error;
    }
};

export const addDepartment = async (data) => {
    const res = await fetchWithAuth("ADMINRoutes/CreateDepts", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return res.json();
  };
  
  // POST update department
  export const updateDepartment = async (data) => {
    const res = await fetchWithAuth("ADMINRoutes/EditDepts", {
      method: "POST",
      body: JSON.stringify({ ...data, IsActive: 1 }),
    });
    return res.json();
  };
  
  // POST inactivate department
  export const inActiveDepartment = async (data) => {
    const res = await fetchWithAuth("ADMINRoutes/INACTIVEDepts", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return res.json();
  };
